import React from "react";
import { Suspense } from "react";

// react router dom
import { Route, Routes } from "react-router-dom";
import SpinnerLayout from "../../core/components/layout/SpinnerLayout";
import ProtectedRoute from "../../layout/ProtectedLayout/ProtectedRoute";
import { RouteMode } from "../../constant/enum/RouteAccessLevel";

// components
import AccountLayout from "../../layout/AccounLayout";
import { AccountantRoute } from "../../routers/AccountantRoute";

const Accounting = () => {
  const renderRoute = () => {
    return AccountantRoute.map((route, index) => (
      <Route key={route.path} path={route.path} element={route.component} />
    ));
  };

  return (
    <ProtectedRoute layoutMode={RouteMode.ACCOUNTANT_ROUTE}>
      <AccountLayout>
        <Suspense fallback={<SpinnerLayout />}>
          <Routes>{renderRoute()}</Routes>
        </Suspense>
      </AccountLayout>
    </ProtectedRoute>
  );
};

export default Accounting;
